var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0.5C14.3807 0.5 15.5 1.61929 15.5 3V10.5H23C24.3807 10.5 25.5 11.6193 25.5 13C25.5 14.3807 24.3807 15.5 23 15.5H15.5V23C15.5 24.3807 14.3807 25.5 13 25.5C11.6193 25.5 10.5 24.3807 10.5 23V15.5H3C1.61929 15.5 0.5 14.3807 0.5 13C0.5 11.6193 1.61929 10.5 3 10.5H10.5V3C10.5 1.61929 11.6193 0.5 13 0.5Z",
    fill: "#0923E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBlue);
export default __webpack_public_path__ + "static/media/plus-blue.31c040fe53cebb4cc3ed92f8b203c3d4.svg";
export { ForwardRef as ReactComponent };